// extracted by mini-css-extract-plugin
module.exports = {"uploadZone":"styles_uploadZone__dVZF9","dropzone":"styles_dropzone__2EUee","dropzoneActive":"styles_dropzoneActive__15muq","highlight":"styles_highlight__1v-J9"};